import type { Control } from "react-hook-form";
import { ActiveFiltersSummary } from "web_myplann/Portfolio/Components/Redesign/Filter/ActiveFiltersSummary";
import { CategoryFilterSection } from "web_myplann/Portfolio/Components/Redesign/Filter/CategoryFilterSection";
import { ContractStateSection } from "web_myplann/Portfolio/Components/Redesign/Filter/ContractStateSection";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { SortFilterSection } from "web_myplann/Portfolio/Components/Redesign/Filter/SortFilterSection";
import { useHasArchivedItems } from "web_myplann/Portfolio/Hooks/useHasArchivedItems";

type Props = {
	control: Control<FilterFormValues>;
};

export const PortfolioFilterFormFields = ({ control }: Props) => {
	const showContractState = useHasArchivedItems();

	return (
		<>
			{showContractState && <ContractStateSection control={control} />}
			<CategoryFilterSection control={control} />
			<SortFilterSection control={control} />
			<ActiveFiltersSummary control={control} />
		</>
	);
};
